"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeMatcher = void 0;
/**
  When the match function is called, it will return true if the argument
  matches a particular character range.

  */
var RangeMatcher = /** @class */ (function () {
    /**
     *
     * @constructor
     * @param ranges
     * @param include
     */
    function RangeMatcher(ranges, include) {
        this.ranges = ranges;
        this.include = include;
        // list of [ start, end ]
        // this.ranges = ranges;
        // this.include = include; // boolean
    }
    RangeMatcher.prototype.match = function (ch) {
        for (var i = 0; i < this.ranges.length; i++) {
            var range = this.ranges[i];
            if (ch >= range[0] && ch <= range[1]) {
                return this.include;
            }
        }
        return !this.include;
    };
    RangeMatcher.prototype.toString = function () {
        var str = '[';
        if (!this.include) {
            str += '^';
        }
        for (var i = 0; i < this.ranges.length; i++) {
            if (this.ranges[i][0] == this.ranges[i][1]) {
                str += this.ranges[i][0];
            }
            else {
                str += this.ranges[i][0] + '-' + this.ranges[i][1];
            }
        }
        return str + ']';
    };
    return RangeMatcher;
}());
exports.RangeMatcher = RangeMatcher;
//# sourceMappingURL=RangeMatcher.js.map